import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxHttpErrorResponse } from '@onyx/angular';
import { ONYX_TOASTS_LIMIT, OnyxToastService } from '@onyx/angular';
import { get, reverse } from 'lodash';
import { CONFLICT_ERROR_CODE } from '../constants/common/conflict-error-code';
import type { ConflictField } from '../interfaces/utilities/conflict-field';

@Service()
export class ConflictHelper {
  private readonly toastService = inject(OnyxToastService);
  private readonly translateService = inject(TranslateService);

  public handleConflictErrors(
    response: OnyxHttpErrorResponse,
    fields: ConflictField[],
  ): boolean {
    const errors = fields
      .filter(({ key }) => get(response.error, key) === CONFLICT_ERROR_CODE)
      .slice(0, ONYX_TOASTS_LIMIT);
    if (!errors.length) return false;

    for (const { message, description, params } of reverse(errors)) {
      this.toastService.showError({
        message: this.translateService.instant(message, params),
        ...(description && {
          description: this.translateService.instant(description, params),
        }),
      });
    }

    response.handled = true;
    return true;
  }
}
